export default __webpack_public_path__ + "static/media/elevate-gry-poster-2.130db308.jpg";